import React from 'react';
import s from './ListOfInvoices.module.css';
import LightGreenButton from '../../Components/Buttons/LightGreenButton';
import {OrderHistoryType} from '../../types/TypesStore';
import {useTranslation} from 'react-i18next';

type Props = {
	ordersHistory: OrderHistoryType[];
	onLoadMore?: () => void;
	hasMore?: boolean;
};
const HistoryOfChangesInvoice: React.FC<Props> = ({
	ordersHistory,
	onLoadMore,
	hasMore,
}) => {
	const {t} = useTranslation();
	return (
		<div className={s.historyOfChangeContainer}>
			<div className={s.historyTitle}>{t('Історія зміни оформлень')}</div>
			<ul className={s.historyList}>
				{ordersHistory.map((item: OrderHistoryType) => (
					<li className={s.historyItem} key={item.order_id}>
						<div className={s.historyItemID}>№ {item.order_id}</div>
						<div className={s.historyItemText}>{item.action_text}</div>
						<div className={s.historyItemAction}>
							<div className={s.historyItemAction_Time}>{item.action_date}</div>
							<div className={s.historyItemAction_Action}>
								{item.action_comment}
							</div>
						</div>
					</li>
				))}
			</ul>
			{hasMore && onLoadMore && (
				<div className={s.historyButtonWrapper}>
					<LightGreenButton
						text={t('дивитися більше')}
						onClick={onLoadMore}
						type={'button'}
					/>
				</div>
			)}
		</div>
	);
};

export default HistoryOfChangesInvoice;
